'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = undefined;
exports.storiesOf = storiesOf;
exports.registerDisposer = registerDisposer;
exports.registerInitializer = registerInitializer;
exports.action = action;

var _mobx = require('mobx');

var _devNovel = require('./dev-novel');

var _devNovel2 = _interopRequireDefault(_devNovel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var devNovel = new _devNovel2.default();

function storiesOf(parentName) {
  return devNovel._bindedInstance({ parentName: parentName });
}

function registerDisposer(disposer) {
  devNovel.disposers.push(disposer);
}

function registerInitializer(initializer) {
  devNovel.initializers.push(initializer);
}

function action(name) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    devNovel.actionLogs.push({
      name: name,
      data: Array.from(args).map(function (arg) {
        return arg && arg.preventDefault ? '[SyntheticEvent]' : arg;
      })
    });
  };
}

var start = exports.start = (0, _mobx.action)(function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  devNovel.applyOpts(opts);
  devNovel.initSelectedStory();
  devNovel.injectUI();
  devNovel.loadSelectedStory();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dev-novel/dist/index.js
// module id = 4
// module chunks = 0